/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Permanent_BanInputs */



/**
* | output |
* | --- |
* | "Permanent ban" |
*
* @param {Sanction_Permanent_BanInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_permanent_ban = /** @type {((inputs?: Sanction_Permanent_BanInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Permanent_BanInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bannissement permanent")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suspensión permanente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Banimento permanente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ban permanente")
	return /** @type {LocalizedString} */ ("Permanent ban")
});